import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const api = {
  // chat
  sendChat: (message, image_base64 = null) =>
    client.post("/chat", { message, image_base64 }).then((r) => r.data),
  getHistory: () => client.get("/chat/history").then((r) => r.data),
  clearHistory: () => client.delete("/chat/history").then((r) => r.data),

  // voice
  voiceChat: (blob) => {
    const fd = new FormData();
    fd.append("audio", blob, "clip.webm");
    return client.post("/voice/chat", fd).then((r) => r.data);
  },
  speak: (message) => client.post("/voice/speak", { message }).then((r) => r.data),

  // inspirations
  addInspiration: (file, note = "") => {
    const fd = new FormData();
    fd.append("image", file);
    fd.append("note", note);
    return client.post("/inspirations", fd).then((r) => r.data);
  },
  getInspirations: () => client.get("/inspirations").then((r) => r.data),
  deleteInspiration: (id) => client.delete(`/inspirations/${id}`).then((r) => r.data),

  // designs
  generateDesign: (prompt, category, collection) =>
    client.post("/designs/generate", { prompt, category, collection }).then((r) => r.data),
  generateVariations: (id) => client.post(`/designs/${id}/variations`).then((r) => r.data),
  getDesigns: (params = {}) => client.get("/designs", { params }).then((r) => r.data),
  patchDesign: (id, body) => client.patch(`/designs/${id}`, body).then((r) => r.data),
  deleteDesign: (id) => client.delete(`/designs/${id}`).then((r) => r.data),
  getCollections: () => client.get("/collections").then((r) => r.data),

  // business
  getPlan: () => client.get("/business/plan").then((r) => r.data),
  generatePlan: (prompt = null) => client.post("/business/plan", { prompt }).then((r) => r.data),
  downloadDeck: () => client.get("/business/deck", { responseType: "blob" }).then((r) => r.data),

  // tasks
  getTasks: () => client.get("/tasks").then((r) => r.data),
  generateTasks: () => client.post("/tasks/generate").then((r) => r.data),
  createTask: (body) => client.post("/tasks", body).then((r) => r.data),
  patchTask: (id, body) => client.patch(`/tasks/${id}`, body).then((r) => r.data),
  deleteTask: (id) => client.delete(`/tasks/${id}`).then((r) => r.data),

  // fundraising
  getFundraising: () => client.get("/fundraising").then((r) => r.data),
  patchFundraising: (body) => client.patch("/fundraising", body).then((r) => r.data),
};
